import { AuthUser, UsersDTO } from '../../../redux/identity/identityTypes';

export const getUserName = (user: AuthUser | UsersDTO | null | undefined): string => {
	if (!user) return '';
	if ('Name' in user && user.Name) {
		return user.Surname ? `${user.Name} ${user.Surname}` : user.Name;
	}
	if ('name' in user && user.name) {
		return user.name;
	}
	return '';
};

export type DatabaseItem = {
	id: string;
	name: string;
};

export const getDatabasesFromUser = (user: AuthUser | null): DatabaseItem[] => {
	if (!user || !user?.databases) {
		return [];
	}

	const splitValues = user.databases.map((d: string) => ({
		id: d.split(':')[0],
		name: d.split(':')[1],
	}));
	return splitValues;
};

export const getActiveDatabase = (
	databasesList: DatabaseItem[],
	currentlyActiveDb: string | undefined,
): string => {
	if (databasesList.length === 0) {
		return '';
	}

	const activeDatabase = databasesList.find((d) => d.id === currentlyActiveDb);
	if (activeDatabase) {
		return activeDatabase.id;
	}

	return databasesList[0].id;
};

export const getActiveDatabaseName = (user: AuthUser | null): string => {
	const databasesList = getDatabasesFromUser(user);
	if (databasesList.length === 0) {
		return '';
	}

	const activeDatabase = databasesList.find((d) => d.id === user?.currentlyActiveDb);
	if (activeDatabase) {
		return activeDatabase.name;
	}

	return databasesList[0].name;
};